import { validateLevel } from '../core/level';
import type { Level } from '../core/types';
import data from './levels.json';

export interface Chapter {
  n: number;
  numeral: string;
  title: string;
  blurb: string;
}

export const CHAPTERS: Chapter[] = [
  {
    n: 1,
    numeral: 'I',
    title: 'First Light',
    blurb: 'Bending, distance, one mass on many beams, and the first lenses.',
  },
  {
    n: 2,
    numeral: 'II',
    title: 'Colour and Stone',
    blurb: 'Coloured light, walls, rocks, dust and masses fixed in place.',
  },
  {
    n: 3,
    numeral: 'III',
    title: 'The Dark',
    blurb: 'Black holes, voids that push light away, and nebulae that tint it.',
  },
];

/** The bundled campaign, validated once at start-up. */
export const LEVELS: Level[] = (data as unknown[]).map((d, i) => {
  const v = validateLevel(d);
  if (!v.ok) throw new Error(`Bundled level ${i + 1} is invalid: ${v.errors.join('; ')}`);
  return v.level;
});

export function levelNumber(id: string): number {
  return LEVELS.findIndex((l) => l.id === id) + 1;
}

export function chapterOf(id: string): Chapter {
  const n = Number(id.split('-')[0]);
  return CHAPTERS.find((c) => c.n === n) ?? CHAPTERS[0]!;
}

/** "II · 4" style label. */
export function levelLabel(id: string): string {
  const [c, k] = id.split('-');
  const ch = CHAPTERS.find((x) => x.n === Number(c));
  return `${ch?.numeral ?? c} · ${k}`;
}
